import React from "react";

const Footer = () => {
  return (
    <div className="developed-by">
      <a
        href="https://www.bharat-online.com/"
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "inherit", textDecoration: "none", textDecorationLine: "underline" }}
      >
        Developed by Bharat Online
      </a>
    </div>
  );
};

export default Footer;
